import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset, Field, Control, Button } from "rbx";

import TariffRateForm from "./TariffRateForm";
import { CREATE_TARIFF_RATE_MUTATION } from "../../graphql/Tariffs/Tariffs.graphql";
import { ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  MaxMiles: "",
  Rate: ""
};

function AddTariffRateForm({ id, onComplete }) {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE
  });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const [createTariffRate, { loading }] = useMutation(
    CREATE_TARIFF_RATE_MUTATION,
    {
      refetchQueries: ["ALL_TARIFF_RATES_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      await createTariffRate({
        variables: {
          data: {
            ...inputs,
            TariffRecIdRef: parseInt(id),
            MaxMiles: parseInt(inputs.MaxMiles),
            Rate: parseFloat(inputs.Rate)
          }
        }
      });
      toast.success("Tariff Rate added successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error adding Tariff Rate.");
    }
  };
  return (
    <div className="add-tariff-rate-form">
      <Title>Add Tariff Rate</Title>
      <form id="add-tariff-rate-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <TariffRateForm inputs={inputs} onChange={handleChange} />
          <hr />
          <Field kind="group">
            <Control>
              <Button color="primary" form="add-tariff-rate-form" type="submit">
                Submit
              </Button>
            </Control>
            <Control>
              <Button type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </div>
  );
}

AddTariffRateForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func
};

export default AddTariffRateForm;
